/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */
import type {
  CreateDcaiPlanDTO,
  DcaiSimulationRequest,
  GetDcaiHealth200,
  GetDcaiHealth401,
  GetDcaiHealth500,
  GetDcaiHealth503,
  GetDcaiHealth504,
  GetDcaiPlans200,
  GetDcaiPlans401,
  GetDcaiPlansId200,
  GetDcaiPlansId401,
  GetDcaiPlansId403,
  GetDcaiPlansId404,
  GetDcaiPlansIdCycles200,
  GetDcaiPlansIdCycles401,
  GetDcaiPlansIdCycles403,
  GetDcaiPlansIdCycles404,
  GetDcaiPlansIdCyclesParams,
  GetDcaiPlansIdParams,
  GetDcaiPlansIdPnl200,
  GetDcaiPlansIdPnl401,
  GetDcaiPlansIdPnl403,
  GetDcaiPlansIdPnl404,
  GetDcaiPlansIdPnlParams,
  GetDcaiPlansParams,
  GetDcaiPnl200,
  GetDcaiPnl401,
  GetDcaiPnlParams,
  PostDcaiPlans201,
  PostDcaiPlans400,
  PostDcaiPlans401,
  PostDcaiPlans409,
  PostDcaiPlansIdDisable200,
  PostDcaiPlansIdDisable401,
  PostDcaiPlansIdDisable403,
  PostDcaiPlansIdDisable404,
  PostDcaiPlansIdDisable422,
  PostDcaiSimulation200,
  PostDcaiSimulation400,
  PostDcaiSimulation401,
  PostDcaiTemporalPlansIdProcessCycle200,
  PostDcaiTemporalPlansIdProcessCycle401,
  PostDcaiTemporalPlansIdProcessCycle403,
  PostDcaiTemporalPlansIdProcessCycle404,
  PostDcaiTemporalPlansIdProcessCycle422,
  ProcessDcaiCycleBodyDTO
} from '../../models';

import { customFetch } from '../../mutator/customFetch';

/**
 * Cria um plano de DCA Inteligente: compras periódicas **reais** de cripto na
Bybit, com o valor de cada compra ajustado por um sinal de mercado
(multiplicador 0.4×–1.7× sobre o aporte). O ativo comprado fica **custodiado e
bloqueado** enquanto o plano está ativo, e é **devolvido à carteira do usuário
ao desativar** o plano (`POST /dcai/plans/{id}/disable`).

O par negociado (`symbol`) é derivado de `baseCoin` + `quoteCoin`
(ex.: BTC + USDT → BTCUSDT) — não é enviado na request.

**Agendamento (`nextRunAt`)**:
- **WEEKLY**: âncora fixa **domingo 23:59 UTC**. `nextRunAt` = próximo
  domingo 23:59 UTC após `now`.
- **MONTHLY**: `now + 30 dias`.
- **HALF_HOURLY / MINUTELY** (apenas testes — `400` sem a feature flag
  `dcai.fast_cycles.enabled` ativa): `now + 30 min / 1 min`, primeiro ciclo
  sempre enfileirado. Útil para validar o fluxo completo.
- **BIWEEKLY / QUARTERLY**: **descontinuadas** — `400` para novos planos;
  planos antigos seguem ciclando (14 / 90 dias).

**Primeiro ciclo na criação** (processado de forma **assíncrona** pela fila —
durável a quedas/reinícios da aplicação):
- **WEEKLY**: é enfileirado somente se faltarem **≥ 4 dias** até o próximo
  domingo 23:59 UTC (≈ metade do intervalo). Caso contrário, a primeira
  cobrança fica para `nextRunAt`.
- **MONTHLY**: é enfileirado **sempre**.

**Financiamento**: cada ciclo gasta o saldo do usuário em `quoteCoin`
(`ASSET:BYBIT_SUB:{userId}:{quoteCoin}` no Ledger). Se o saldo não cobrir o
alvo do sinal (incluindo a folga de fee), o ciclo entra como `SKIPPED`
(`INSUFFICIENT_BALANCE_FOR_TARGET`, ou `INSUFFICIENT_CASH` se zerado) — sem
compra parcial — e o plano continua ACTIVE; o cron tenta de novo na
`nextRunAt`.

**Resposta**: `{ plan, firstCycle: null }` — o primeiro ciclo roda pela fila
(em segundos); acompanhe o resultado em `GET /dcai/plans/{id}/cycles`.

**Restrição**: apenas um plano ACTIVE por usuário/símbolo (`409 Conflict` caso contrário).

**Exemplo de corpo**:

```json
{
  "baseCoin": "BTC",
  "quoteCoin": "USDT",
  "contributionAmount": "500",
  "frequency": "WEEKLY"
}
```
 * @summary Criar plano DCAI
 */
export type postDcaiPlansResponse201 = {
  data: PostDcaiPlans201
  status: 201
}

export type postDcaiPlansResponse400 = {
  data: PostDcaiPlans400
  status: 400
}

export type postDcaiPlansResponse401 = {
  data: PostDcaiPlans401
  status: 401
}

export type postDcaiPlansResponse409 = {
  data: PostDcaiPlans409
  status: 409
}

export type postDcaiPlansResponseSuccess = (postDcaiPlansResponse201) & {
  headers: Headers;
};
export type postDcaiPlansResponseError = (postDcaiPlansResponse400 | postDcaiPlansResponse401 | postDcaiPlansResponse409) & {
  headers: Headers;
};

export type postDcaiPlansResponse = (postDcaiPlansResponseSuccess | postDcaiPlansResponseError)

export const getPostDcaiPlansUrl = () => {


  

  return `https://api.wedofi.com/dcai/plans`
}

export const postDcaiPlans = async (createDcaiPlanDTO: CreateDcaiPlanDTO, options?: RequestInit): Promise<postDcaiPlansResponse> => {
  
  return customFetch<postDcaiPlansResponse>(getPostDcaiPlansUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDcaiPlanDTO,)
  }
);}
  

/**
 * Lista os planos DCAI do usuário autenticado, com paginação por offset.

Útil para dashboards: mostra status, próxima execução (`nextRunAt`),
frequência e os contadores de ciclos:
`totalCyclesCount`, `completedCyclesCount`, `skippedCyclesCount`. Para
saber se o primeiro ciclo já foi cobrado, basta olhar `completedCyclesCount > 0`
(ou `totalCyclesCount > 0` para incluir SKIPPED/FAILED).

**Filtros** (sem `status`, retorna todos):
- `status=ACTIVE` → planos em execução
- `status=DISABLING` → desativação em andamento (aguardando devolução do ativo)
- `status=DISABLED` → histórico de planos encerrados

**Paginação**:
- `page` base 1, `limit` 1..100 (default 10).
 * @summary Listar planos do usuário
 */
export type getDcaiPlansResponse200 = {
  data: GetDcaiPlans200
  status: 200
}

export type getDcaiPlansResponse401 = {
  data: GetDcaiPlans401
  status: 401
}

export type getDcaiPlansResponseSuccess = (getDcaiPlansResponse200) & {
  headers: Headers;
};
export type getDcaiPlansResponseError = (getDcaiPlansResponse401) & {
  headers: Headers;
};

export type getDcaiPlansResponse = (getDcaiPlansResponseSuccess | getDcaiPlansResponseError)

export const getGetDcaiPlansUrl = (params?: GetDcaiPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/dcai/plans?${stringifiedParams}` : `https://api.wedofi.com/dcai/plans`
}

export const getDcaiPlans = async (params?: GetDcaiPlansParams, options?: RequestInit): Promise<getDcaiPlansResponse> => {
  
  return customFetch<getDcaiPlansResponse>(getGetDcaiPlansUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna o estado atual de um plano: status, próxima execução, acumulado em
`baseCoin` (`accumulatedBaseAmount`) e demais metadados. O saldo real do
usuário vive no Ledger (`ASSET:BYBIT_SUB:{userId}:{coin}`).

Falha com **403** se o plano não pertencer ao usuário-alvo e com **404** se não
existir. Admin pode informar `userId` para ver o plano de outro usuário.
 * @summary Obter plano por ID
 */
export type getDcaiPlansIdResponse200 = {
  data: GetDcaiPlansId200
  status: 200
}

export type getDcaiPlansIdResponse401 = {
  data: GetDcaiPlansId401
  status: 401
}

export type getDcaiPlansIdResponse403 = {
  data: GetDcaiPlansId403
  status: 403
}

export type getDcaiPlansIdResponse404 = {
  data: GetDcaiPlansId404
  status: 404
}

export type getDcaiPlansIdResponseSuccess = (getDcaiPlansIdResponse200) & {
  headers: Headers;
};
export type getDcaiPlansIdResponseError = (getDcaiPlansIdResponse401 | getDcaiPlansIdResponse403 | getDcaiPlansIdResponse404) & {
  headers: Headers;
};

export type getDcaiPlansIdResponse = (getDcaiPlansIdResponseSuccess | getDcaiPlansIdResponseError)

export const getGetDcaiPlansIdUrl = (id: string,
    params?: GetDcaiPlansIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/dcai/plans/${id}?${stringifiedParams}` : `https://api.wedofi.com/dcai/plans/${id}`
}

export const getDcaiPlansId = async (id: string,
    params?: GetDcaiPlansIdParams, options?: RequestInit): Promise<getDcaiPlansIdResponse> => {
  
  return customFetch<getDcaiPlansIdResponse>(getGetDcaiPlansIdUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Inicia a desativação: o plano para de operar (não gera novos ciclos) e responde
com `status = DISABLING`. Em background, um job devolve o ativo bloqueado da
subconta central para a subconta do cliente (transfer Bybit + Ledger). **Só
quando essa devolução é confirmada** o plano vira `status = DISABLED`
(consulte `GET /dcai/plans/{id}` para acompanhar). Se o release falhar, o plano
permanece em `DISABLING` (não volta a comprar) até concluir. `422` se o plano
já não estiver ACTIVE.
 * @summary Desativar plano
 */
export type postDcaiPlansIdDisableResponse200 = {
  data: PostDcaiPlansIdDisable200
  status: 200
}

export type postDcaiPlansIdDisableResponse401 = {
  data: PostDcaiPlansIdDisable401
  status: 401
}

export type postDcaiPlansIdDisableResponse403 = {
  data: PostDcaiPlansIdDisable403
  status: 403
}

export type postDcaiPlansIdDisableResponse404 = {
  data: PostDcaiPlansIdDisable404
  status: 404
}

export type postDcaiPlansIdDisableResponse422 = {
  data: PostDcaiPlansIdDisable422
  status: 422
}

export type postDcaiPlansIdDisableResponseSuccess = (postDcaiPlansIdDisableResponse200) & {
  headers: Headers;
};
export type postDcaiPlansIdDisableResponseError = (postDcaiPlansIdDisableResponse401 | postDcaiPlansIdDisableResponse403 | postDcaiPlansIdDisableResponse404 | postDcaiPlansIdDisableResponse422) & {
  headers: Headers;
};

export type postDcaiPlansIdDisableResponse = (postDcaiPlansIdDisableResponseSuccess | postDcaiPlansIdDisableResponseError)

export const getPostDcaiPlansIdDisableUrl = (id: string,) => {


  

  return `https://api.wedofi.com/dcai/plans/${id}/disable`
}

export const postDcaiPlansIdDisable = async (id: string, options?: RequestInit): Promise<postDcaiPlansIdDisableResponse> => {
  
  return customFetch<postDcaiPlansIdDisableResponse>(getPostDcaiPlansIdDisableUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * PnL de um único plano DCAI. Custo (`invested`) e quantidade (`qty`) vêm dos
ciclos COMPLETED do plano; o preço atual vem do mercado Bybit.

`unrealizedPnl = qty × currentPrice − invested` e
`pnlPercent = unrealizedPnl / invested × 100`.

Planos `DISABLED` retornam `closed=true` (ativo já devolvido em espécie, sem
PnL ao vivo). Falha com **403** se o plano não pertencer ao usuário-alvo e
**404** se não existir. Admin pode informar `userId`.
 * @summary PnL de um plano DCAI
 */
export type getDcaiPlansIdPnlResponse200 = {
  data: GetDcaiPlansIdPnl200
  status: 200
}

export type getDcaiPlansIdPnlResponse401 = {
  data: GetDcaiPlansIdPnl401
  status: 401
}

export type getDcaiPlansIdPnlResponse403 = {
  data: GetDcaiPlansIdPnl403
  status: 403
}

export type getDcaiPlansIdPnlResponse404 = {
  data: GetDcaiPlansIdPnl404
  status: 404
}

export type getDcaiPlansIdPnlResponseSuccess = (getDcaiPlansIdPnlResponse200) & {
  headers: Headers;
};
export type getDcaiPlansIdPnlResponseError = (getDcaiPlansIdPnlResponse401 | getDcaiPlansIdPnlResponse403 | getDcaiPlansIdPnlResponse404) & {
  headers: Headers;
};

export type getDcaiPlansIdPnlResponse = (getDcaiPlansIdPnlResponseSuccess | getDcaiPlansIdPnlResponseError)

export const getGetDcaiPlansIdPnlUrl = (id: string,
    params?: GetDcaiPlansIdPnlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/dcai/plans/${id}/pnl?${stringifiedParams}` : `https://api.wedofi.com/dcai/plans/${id}/pnl`
}

export const getDcaiPlansIdPnl = async (id: string,
    params?: GetDcaiPlansIdPnlParams, options?: RequestInit): Promise<getDcaiPlansIdPnlResponse> => {
  
  return customFetch<getDcaiPlansIdPnlResponse>(getGetDcaiPlansIdPnlUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Lista os ciclos do plano ordenados por `sequence`, na direção do parâmetro
`order` (default `asc`: 1, 2, 3…).

Cada ciclo guarda **snapshots de saldo antes/depois**, o sinal aplicado
(`signalCategory`, `signalMultiplier`), o preço Bybit usado no cálculo
(`price` — origem em `rawSignal.priceSource`, visível só para admin) e os
valores reais da compra (`targetBuyAmount`, `finalBuyAmount`,
`assetBought`) — útil para auditoria e para reproduzir o cálculo.

**Paginação por cursor**:
- `limit`: 1..50 (default 50).
- `after` = `sequence` do último ciclo da página atual (avança na ordem
  exibida); `before` = `sequence` do primeiro (retrocede).
- `order=desc` (scroll infinito de histórico): primeira página traz os
  ciclos mais **recentes**; `after` avança para os mais **antigos** e
  `before` volta para os mais recentes.

**Status do ciclo**:
- `COMPLETED` — compra real executada na Bybit e custodiada (bloqueada no DCA
  do usuário até desativar o plano). Sempre compra o alvo cheio do sinal.
- `SKIPPED` — nada comprado; motivo em `skipReason`: `INSUFFICIENT_CASH`
  (saldo zerado), `INSUFFICIENT_BALANCE_FOR_TARGET` (saldo insuficiente para o
  alvo do sinal, incluindo a folga de fee), `ZERO_TARGET`,
  `AMOUNT_BELOW_MIN_ORDER` / `QTY_BELOW_MIN_ORDER` (mínimos da Bybit para o
  par).
- `FAILED` — erro no sinal/preço ou na compra (ex.: saldo usado em outra
  operação no mesmo instante). **Rollback automático: nenhum fundo é
  perdido**; motivo em `errorReason`. O plano segue ACTIVE e tenta no
  próximo agendamento.
 * @summary Listar ciclos de um plano
 */
export type getDcaiPlansIdCyclesResponse200 = {
  data: GetDcaiPlansIdCycles200
  status: 200
}

export type getDcaiPlansIdCyclesResponse401 = {
  data: GetDcaiPlansIdCycles401
  status: 401
}

export type getDcaiPlansIdCyclesResponse403 = {
  data: GetDcaiPlansIdCycles403
  status: 403
}

export type getDcaiPlansIdCyclesResponse404 = {
  data: GetDcaiPlansIdCycles404
  status: 404
}

export type getDcaiPlansIdCyclesResponseSuccess = (getDcaiPlansIdCyclesResponse200) & {
  headers: Headers;
};
export type getDcaiPlansIdCyclesResponseError = (getDcaiPlansIdCyclesResponse401 | getDcaiPlansIdCyclesResponse403 | getDcaiPlansIdCyclesResponse404) & {
  headers: Headers;
};

export type getDcaiPlansIdCyclesResponse = (getDcaiPlansIdCyclesResponseSuccess | getDcaiPlansIdCyclesResponseError)

export const getGetDcaiPlansIdCyclesUrl = (id: string,
    params?: GetDcaiPlansIdCyclesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/dcai/plans/${id}/cycles?${stringifiedParams}` : `https://api.wedofi.com/dcai/plans/${id}/cycles`
}

export const getDcaiPlansIdCycles = async (id: string,
    params?: GetDcaiPlansIdCyclesParams, options?: RequestInit): Promise<getDcaiPlansIdCyclesResponse> => {
  
  return customFetch<getDcaiPlansIdCyclesResponse>(getGetDcaiPlansIdCyclesUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna o **Profit & Loss (PnL) do DCAI** do usuário, calculado pela fórmula
**própria** da plataforma (no estilo Bybit), pois os ativos de DCAI de todos os
usuários ficam na subconta Bybit central — o PnL por usuário da Bybit não se
aplica.

Considera apenas planos `ACTIVE`/`DISABLING` (posições ainda custodiadas;
planos `DISABLED` já devolveram o ativo). Tudo denominado na `quoteCoin` dos
planos (hoje, USDT).

**Fórmula** (por moeda e por plano), sobre os ciclos COMPLETED:
```
invested      = Σ finalBuyAmount          (custo em quoteCoin, fees embutidas)
qty           = Σ assetBought             (base líquida acumulada)
avgBuyPrice   = invested / qty
marketValue   = qty × currentPrice        (preço de mercado Bybit)
unrealizedPnl = marketValue − invested
pnlPercent    = unrealizedPnl / invested × 100
```

Retorna o total consolidado, a quebra por moeda (`byCoin`, com saldo custodiado
e flag de reconciliação) e por plano (`byPlan`). Se alguma cotação ficar
indisponível, os campos de mercado vêm `null` e `partial=true`.
 * @summary PnL agregado do DCAI do usuário
 */
export type getDcaiPnlResponse200 = {
  data: GetDcaiPnl200
  status: 200
}

export type getDcaiPnlResponse401 = {
  data: GetDcaiPnl401
  status: 401
}

export type getDcaiPnlResponseSuccess = (getDcaiPnlResponse200) & {
  headers: Headers;
};
export type getDcaiPnlResponseError = (getDcaiPnlResponse401) & {
  headers: Headers;
};

export type getDcaiPnlResponse = (getDcaiPnlResponseSuccess | getDcaiPnlResponseError)

export const getGetDcaiPnlUrl = (params?: GetDcaiPnlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/dcai/pnl?${stringifiedParams}` : `https://api.wedofi.com/dcai/pnl`
}

export const getDcaiPnl = async (params?: GetDcaiPnlParams, options?: RequestInit): Promise<getDcaiPnlResponse> => {
  
  return customFetch<getDcaiPnlResponse>(getGetDcaiPnlUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Executa **agora** um ciclo do plano sem esperar o cron `tick_due_plans`.
Em produção, esse fluxo é responsabilidade exclusiva do worker BullMQ — este
endpoint existe **apenas para QA / depuração / demonstrações** e em
**produção é restrito a usuários admin** (permite ciclos fora da agenda e
sinal/preço forçados). Em dev/local/test, o dono do plano pode chamar.

**Idempotência**: o par (`planId`, `scheduledFor`) é único. Chamadas
repetidas com o mesmo `scheduledFor` retornam o ciclo já existente sem
alterar saldos no Ledger nem submeter nova ordem.

**Comportamento**:
1. Busca `plan.nextRunAt` (ou usa o `scheduledFor` informado no body, ou `now()`).
2. Lê o caixa do usuário no Ledger (`ASSET:BYBIT_SUB:{userId}:{quoteCoin}`)
   e o bloqueado do DCA (`ASSET:DCAI:{userId}:{baseCoin}_FROZEN`).
3. Obtém **sinal** (`category`, `multiplier`) da **API DCAI Combo 1 real**
   (`GET /combo1/decision` — sinal do dia corrente), ou `forceCategory` no body
   (QA, sem consultar a API). Se a API estiver fora, o ciclo falha (FAILED) —
   nunca compra com sinal inventado.
4. Obtém **preço** via Bybit. Se a cotação estiver indisponível, o ciclo falha
   e nenhuma ordem é enviada.
5. Calcula `finalBuyAmount = min(contributionAmount × multiplier, caixa)`.
6. Se `COMPLETED`: a compra é executada **pelo módulo Trading** na subconta
   do usuário (ordem marcada com origem DCAI), a base líquida é transferida
   para a subconta central e congelada em `ASSET:DCAI:{userId}:{base}_FROZEN`.
   O ciclo é ajustado com os valores reais (`cumExecValue`/`cumExecQty`).

**Status possíveis do ciclo**:
- `COMPLETED`: compra real executada e custodiada (frozen no DCA do usuário).
- `SKIPPED`: saldo Ledger insuficiente ou target zerado (nenhuma ordem enviada).
- `FAILED`: erro no gateway de sinal/preço ou na compra (rollback automático —
  nenhum fundo fica órfão).

**Body (QA)**:
- `{}` → preço Bybit + sinal real da API DCAI Combo 1.
- `{ "forceCategory": "PESSIMO" }` → força categoria do sinal.
- `{ "forcePrice": "95000" }` → força preço de execução (`rawSignal.priceSource = FORCED`).
- `{ "scheduledFor": "..." }` → idempotência por par `planId + scheduledFor`.
 * @summary [Temporal/Admin] Disparar ciclo DCAI manualmente
 */
export type postDcaiTemporalPlansIdProcessCycleResponse200 = {
  data: PostDcaiTemporalPlansIdProcessCycle200
  status: 200
}

export type postDcaiTemporalPlansIdProcessCycleResponse401 = {
  data: PostDcaiTemporalPlansIdProcessCycle401
  status: 401
}

export type postDcaiTemporalPlansIdProcessCycleResponse403 = {
  data: PostDcaiTemporalPlansIdProcessCycle403
  status: 403
}

export type postDcaiTemporalPlansIdProcessCycleResponse404 = {
  data: PostDcaiTemporalPlansIdProcessCycle404
  status: 404
}

export type postDcaiTemporalPlansIdProcessCycleResponse422 = {
  data: PostDcaiTemporalPlansIdProcessCycle422
  status: 422
}

export type postDcaiTemporalPlansIdProcessCycleResponseSuccess = (postDcaiTemporalPlansIdProcessCycleResponse200) & {
  headers: Headers;
};
export type postDcaiTemporalPlansIdProcessCycleResponseError = (postDcaiTemporalPlansIdProcessCycleResponse401 | postDcaiTemporalPlansIdProcessCycleResponse403 | postDcaiTemporalPlansIdProcessCycleResponse404 | postDcaiTemporalPlansIdProcessCycleResponse422) & {
  headers: Headers;
};

export type postDcaiTemporalPlansIdProcessCycleResponse = (postDcaiTemporalPlansIdProcessCycleResponseSuccess | postDcaiTemporalPlansIdProcessCycleResponseError)

export const getPostDcaiTemporalPlansIdProcessCycleUrl = (id: string,) => {


  

  return `https://api.wedofi.com/dcai/temporal/plans/${id}/process-cycle`
}

export const postDcaiTemporalPlansIdProcessCycle = async (id: string,
    processDcaiCycleBodyDTO: ProcessDcaiCycleBodyDTO, options?: RequestInit): Promise<postDcaiTemporalPlansIdProcessCycleResponse> => {
  
  return customFetch<postDcaiTemporalPlansIdProcessCycleResponse>(getPostDcaiTemporalPlansIdProcessCycleUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      processDcaiCycleBodyDTO,)
  }
);}
  

/**
 * **Proxy utilitário** (dev/QA) para `GET {DCAI_BASE_URL}/` — não faz parte do fluxo do usuário final. Retorna o estado da API Combo 1, se os CSVs estão configurados (`data_configured`), caminho do store do webhook, etc.
 * @summary Saúde e informação da API DCAI (utilitário dev/QA)
 */
export type getDcaiHealthResponse200 = {
  data: GetDcaiHealth200
  status: 200
}

export type getDcaiHealthResponse401 = {
  data: GetDcaiHealth401
  status: 401
}

export type getDcaiHealthResponse500 = {
  data: GetDcaiHealth500
  status: 500
}

export type getDcaiHealthResponse503 = {
  data: GetDcaiHealth503
  status: 503
}

export type getDcaiHealthResponse504 = {
  data: GetDcaiHealth504
  status: 504
}

export type getDcaiHealthResponseSuccess = (getDcaiHealthResponse200) & {
  headers: Headers;
};
export type getDcaiHealthResponseError = (getDcaiHealthResponse401 | getDcaiHealthResponse500 | getDcaiHealthResponse503 | getDcaiHealthResponse504) & {
  headers: Headers;
};

export type getDcaiHealthResponse = (getDcaiHealthResponseSuccess | getDcaiHealthResponseError)

export const getGetDcaiHealthUrl = () => {


  

  return `https://api.wedofi.com/dcai/health`
}

export const getDcaiHealth = async ( options?: RequestInit): Promise<getDcaiHealthResponse> => {
  
  return customFetch<getDcaiHealthResponse>(getGetDcaiHealthUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Agrega para a UI a série diária pré-calculada do Combo 1, lida da tabela `dcai_sim_daily`.

Compara três estratégias no mesmo período, com valores em USDT:
- `dcai` — aporte base ajustado pelo multiplicador da categoria do dia.
- `dca` — aporte base fixo, sem multiplicador.
- `btcHold` — todo o capital do DCA puro comprado de uma vez no primeiro fechamento da janela.

- Os aportes e as quantidades de BTC são gravados em base 1 USDT por compra e escalados aqui.
- A cadência de compra vem da própria tabela (`is_buy`); `monthly` usa 1 a cada 4 compras.
- O investimento é informado em USDT/mês e convertido para aporte por compra.
- `series` traz os valores **acumulados** em cada data; `summary` é o último ponto da série.

**O resultado é hipotético** (backtest sobre dados históricos) — serve para comparar as estratégias, não é promessa de rentabilidade futura.
 * @summary Simulação DCAI (DCAi vs DCA puro vs BTC hold)
 */
export type postDcaiSimulationResponse200 = {
  data: PostDcaiSimulation200
  status: 200
}

export type postDcaiSimulationResponse400 = {
  data: PostDcaiSimulation400
  status: 400
}

export type postDcaiSimulationResponse401 = {
  data: PostDcaiSimulation401
  status: 401
}

export type postDcaiSimulationResponseSuccess = (postDcaiSimulationResponse200) & {
  headers: Headers;
};
export type postDcaiSimulationResponseError = (postDcaiSimulationResponse400 | postDcaiSimulationResponse401) & {
  headers: Headers;
};

export type postDcaiSimulationResponse = (postDcaiSimulationResponseSuccess | postDcaiSimulationResponseError)

export const getPostDcaiSimulationUrl = () => {


  

  return `https://api.wedofi.com/dcai/simulation`
}

export const postDcaiSimulation = async (dcaiSimulationRequest: DcaiSimulationRequest, options?: RequestInit): Promise<postDcaiSimulationResponse> => {
  
  return customFetch<postDcaiSimulationResponse>(getPostDcaiSimulationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dcaiSimulationRequest,)
  }
);}
  

